// Что показать в пикере: библиотека растёт, и выбирать глазами из сотни
// элементов нечем. Пустой запрос — последние добавленные, непустой — все
// совпадения по имени. Уже выбранные показываются всегда: иначе снять выбор,
// не сбросив поиск, было бы нечем.
//
// 🛑 Порядок карточек — всегда по дате добавления и НИКОГДА не зависит от
// выбора: выделение, переставляющее плитки под курсором, читается как сбой
// интерфейса (замечание владельца на живой приёмке). Выбор только удерживает
// карточку в выдаче, не двигая её.

import type { Element } from "~/entities/element";

/** Сколько последних элементов показываем, пока в поиске ничего не ввели. */
export const RECENT_ELEMENTS_LIMIT = 5;

export interface PickerElementsView {
    items: Element[];
    /** Всего элементов в библиотеке — для подписи «показаны последние N из M». */
    total: number;
    /** Показан сокращённый список последних добавленных, а не результат поиска. */
    isRecent: boolean;
}

const byNewestFirst = (a: Element, b: Element): number => b.createdAt.localeCompare(a.createdAt);

export function selectPickerElements(
    elements: readonly Element[],
    query: string,
    selectedIds: readonly string[],
    recentLimit: number = RECENT_ELEMENTS_LIMIT,
): PickerElementsView {
    const total = elements.length;
    const normalized = query.trim().toLocaleLowerCase();
    // Один отсортированный список на оба режима — из него только отбираем, но
    // не переупорядочиваем, поэтому клик по карточке ничего не двигает.
    const sorted = [...elements].sort(byNewestFirst);

    const items = sorted.filter((element, index) => {
        if (selectedIds.includes(element.id)) return true;
        return normalized.length === 0
            ? index < recentLimit
            : element.name.toLocaleLowerCase().includes(normalized);
    });

    return { items, total, isRecent: normalized.length === 0 && items.length < total };
}
